<template>

    <div v-if="image" class="position-relative">
        <img :src="image" class="border rounded-1" style="height: 60px; width: 60px;" />
        <a href="#" class="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-light text-danger" @click.prevent="deleteImage">
            <i class="fas fa-circle-minus fs-4 fw-bolder"></i>
        </a>
    </div>

    <div v-else>
        <input type="file" :name="inputFileName" class="form-control form-control-sm" />
    </div>

</template>

<script>
    export default {
        props: {
            nameInput: {
                type: String,
                default: 'image-input'
            },
            src: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                image: null,
                previewImage: null,
                inputFileName: null
            }
        },
        created () {
            this.image =  this.src
            this.inputFileName = this.nameInput
        },
        methods: {
            deleteImage () {
                this.image = null
                // TODO axios delete image
            }
        }
    }
</script>
